import { CmsObjectWithDefault } from '@components/Cms/types';

export type SmsPhoneEntryFormCmsKey =
    | 'Title'
    | 'PhoneNumberLabel'
    | 'PhoneNumberPlaceholder'
    | 'InvalidPhone'
    | 'SubmitButtonText'
    | 'ErrorMessage';

export const SmsPhoneEntryFormCmsWithDefault: CmsObjectWithDefault<SmsPhoneEntryFormCmsKey> = {
    Title: {
        cmsId: 558087,
        defaultTranslation: 'Enter phone number',
    },
    PhoneNumberLabel: {
        cmsId: 289854,
        defaultTranslation: 'Phone number',
    },
    PhoneNumberPlaceholder: {
        cmsId: 68691,
        defaultTranslation: '123',
    },
    InvalidPhone: {
        cmsId: 127009,
        defaultTranslation: 'Please enter a valid phone number.',
    },
    SubmitButtonText: {
        cmsId: 558088,
        defaultTranslation: 'Send OTP',
    },
    ErrorMessage: {
        cmsId: 188020,
        defaultTranslation: 'Something went wrong. Please try again.',
    },
};
